module.exports = __webpack_public_path__ + "static/img/RS.166494c0.png";